import React from "react";
import classNames from "classnames";
import { shallowEqual, useSelector } from "react-redux";
import {Models, Assets, Logger, Types, Utils} from "@sendum/core";

import { VisibilityRootState } from "../store/VisibilityStore";
import classes from "./GoNoGo.module.scss";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new Logger("GoNoGo");

export const GoNoGo = (): JSX.Element => {
	const device = useSelector<VisibilityRootState, Models.Device | undefined>((state: VisibilityRootState) => state.Visibility.device, shallowEqual);
	const history = useSelector<VisibilityRootState, Map<string, Types.TProperty[]>>((state: VisibilityRootState) => state.Visibility.history);
	const orderId = useSelector((state: VisibilityRootState) => state.Visibility.orderId);
	const shipment = useSelector((state: VisibilityRootState) => state.Visibility.shipment);
	// const trackingStartTime = useSelector<VisibilityRootState, number | undefined>((state: VisibilityRootState) => state.Visibility.trackingStartTime, shallowEqual);
	// const trackingEndTime = useSelector<VisibilityRootState, number | undefined>((state: VisibilityRootState) => state.Visibility.trackingEndTime, shallowEqual);

	const { startTime, endTime } = shipment && orderId ? Utils.getHistoryEndToEndInterval(shipment, orderId, ["Live"]): { startTime: 0, endTime: 0 };
	const trackingStartTime = startTime;
	const trackingEndTime = endTime;

	const withAlarms = !!device?.getAlarms(["LOWTEMP_PROBE", "LOWTEMPPROBE", "HIGHTEMP_PROBE", "HIGHTEMPPROBE", "REPORT:alarms:LOWTEMP_PROBE", "REPORT:alarms:HIGHTEMP_PROBE", "REPORT:alarms:LOWTEMPPROBE", "REPORT:alarms:HIGHTEMPPROBE"]).filter(alarm => alarm.timestamp > (trackingStartTime || 1) && alarm.timestamp < (trackingEndTime || Date.now())).length;
	const tempProbes = history.get(`${device?.id ?? ""}#${device?.shipment.id ?? ""}#tempProbe`);
	const style = [classes.goNoGo];

	if (!tempProbes || tempProbes.length === 0) {
		style.push(classes.goNoGo_noData);
	} else {
		style.push(withAlarms ? classes.goNoGo_negative : classes.goNoGo_posetive);
	}

	return (
		<div className={classNames(...style)}>
			{tempProbes && tempProbes.length > 0 ? (<img className={classes.goNoGo_img} alt={""} src={withAlarms ? Assets.NoGo : Assets.Go} />) : "No data"}
			{tempProbes && tempProbes.length > 0 && (<span className={classes.goNoGo_text} >{withAlarms ? "Alarm: Yes" : "Alarm: No"}</span>)}
		</div>
	);
};
